import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const validateNotEmpty = value => {
    if (!value || value.trim() === '') {
        return 'This field is required';
    }

    if (value !== value.trim()) {
        return 'cannot start or end with spaces';
    }

    return undefined;
};

export const validatePhoneNumber = value => {
    if (!/^\d{10}$/.test(value)) {
        return 'Phone number must be exactly 10 digits and contain only numbers.';
    }
    return undefined;
};
export const validateEmail = value => {
    if (!value) return undefined;

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(value)) {
        return 'Please enter a valid email address.';
    }

    return undefined;
};
